import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getAlfakitBalance = (params) => {
    return axios.get(`${backendHost}/api/admin/alfakit/check-balance`, {params});
};